import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ad6def"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-wrapper" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "floating-menu-item-name tooltip-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tooltip-arrow" }, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "tooltip-text" }

import { computed } from 'vue'
import NewFeature from '@/layouts/AppLayoutSidebarMenu/NewFeature.vue'
import { i18n } from '@/services/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutSidebarEntry',
  props: {
  icon: {
    type: String,
    required: true,
  },
  translationKey: { type: String, required: true },
  route: { type: String, required: false, default: '' },
  isNew: { type: Boolean, required: false },
},
  setup(__props) {

const props = __props;



const label = computed(() => {
  return i18n.global.t(props.translationKey)
})

const currentIcon = computed((): string => {
  return require(`@/assets/img/${props.icon}`)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, { to: __props.route }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.isNew)
          ? (_openBlock(), _createBlock(NewFeature, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("img", {
          src: currentIcon.value,
          alt: label.value
        }, null, 8 /* PROPS */, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(label.value), 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to"]))
}
}

})